import { IRailVisitItem } from '@planning/rt-stores/railVisit/RailVisitItem'
import { useTranslate } from '@tolgee/react'
import { BreadcrumpItem } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'

export const useRailVisitBreadcrumbs = (railVisitItem?: IRailVisitItem) => {
  const { t } = useTranslate()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const params = useParams()

  const urlId = params.visitId || params.id
  const direction = params.direction

  const isRailPlanningRoute = pathname.includes('rail-visits-planning')
  const isRailDischargeRoute = pathname.includes('/discharge')
  const isRailLoadRoute = pathname.includes('/load')
  const isAddEmptyRailcarRoute = pathname.includes('/railcar/new')

  const isEdit = Boolean(railVisitItem?.id || urlId)

  const railVisitLabel = useMemo(() => {
    if (!railVisitItem) return
    return railVisitItem.data.name || railVisitItem.data.identifier || 'Rail Visit'
  }, [railVisitItem])

  const directionLabel = useMemo(() => {
    if (isRailDischargeRoute) return t('dischargeList', 'Discharge List')
    if (isRailLoadRoute) return t('loadList', 'Load List')
    return null
  }, [isRailDischargeRoute, isRailLoadRoute, t])

  const breadcrumbs = useMemo(() => {
    const basePath = '/rail-visits'
    const currentId = railVisitItem?.id || urlId
    const railVisitDashboardUrl = `/rail-visits/${currentId}/dashboard`
    const listUrl = `/rail-visits/${currentId}/${direction}`

    const items: BreadcrumpItem[] = [
      {
        label: t('railVisits', 'Rail Visits'),
        onClick: () => navigate(basePath),
      },
    ]

    if (railVisitLabel && currentId) {
      items.push({
        label: railVisitLabel,
        onClick: () => navigate(railVisitDashboardUrl),
      })
    }

    if (isRailPlanningRoute) {
      items.push({
        label: isEdit
          ? t('editRailVisit', 'Edit Rail Visit')
          : t('createRailVisit', 'Create Rail Visit'),
      })
    } else if (directionLabel) {
      if (isAddEmptyRailcarRoute) {
        items.push({
          label: directionLabel,
          onClick: () => navigate(listUrl),
        })

        items.push({
          label: t('addEmptyRailcar', 'Add empty railcar'),
        })
      } else {
        items.push({
          label: directionLabel,
        })
      }
    }

    return items
  }, [
    directionLabel,
    isEdit,
    isRailPlanningRoute,
    isAddEmptyRailcarRoute,
    navigate,
    railVisitLabel,
    railVisitItem?.id,
    urlId,
    direction,
    t,
  ])

  return { breadcrumbs, railVisitLabel }
}
